module.exports = __webpack_public_path__ + "si.svg?48107aebf18a50cd1f74f659dff023b3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/si.svg
// module id = 1608
// module chunks = 0